import posthogLib from 'posthog-js';

/**
 * Analytics service that wraps PostHog calls used in Redux slices.
 * Decouples state management from the analytics provider.
 */
export const analytics = {
  captureLoginError(error: unknown): void {
    posthogLib.capture('user_login_error', { error });
  },

  captureLoginRejection(payload: unknown): void {
    posthogLib.capture('user_login_error', { payload });
  },

  captureTokenError(error: unknown): void {
    posthogLib.capture('user_token_error', { error });
  },

  captureUserProperties(properties: Record<string, unknown>): void {
    posthogLib.capture('$set', { $set: properties });
  },

  reset(): void {
    posthogLib.reset();
  }
};
